import Vue from "vue";
import App from "./App.vue";
import Tabs from "buefy/dist/components/tabs";
import Dropdown from "buefy/dist/components/dropdown";
import Modal from "buefy/dist/components/modal/";
import i18n from "@/middlewares/i18n";
import VueSocketIO from "vue-socket.io";
import store from "@/store";
import { Main } from "smck-core";
import io from "socket.io-client";
import "@/plugins/vuetify";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  FlashMessageService,
  GtagPlugin,
  ApiHttpInterceptor
} from "zoox-infra";
import {
  faBars,
  faBell,
  faGlobe,
  faHotel,
  faUsers,
  faTimes,
  faIdBadge,
  faFileAlt,
  faFolderOpen,
  faTimesCircle,
  faPlaneArrival,
  faPlaneDeparture,
  faClipboardList,
  faCalendarCheck,
  faCamera,
  faMobileAlt,
  faAt,
  faPencilAlt,
  faStar,
  faRedo,
  faCheck
} from "@fortawesome/free-solid-svg-icons";
import router from "@/middlewares/router";
import CxltToastr from "cxlt-vue2-toastr";
import "cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css";
import AppLoadService from "./service/app-load-service";
import { Loading, zDebug } from "zoox-components";

const toastrConfigs = {
  position: "top full width",
  showDuration: 500,
  hideDuration: 500,
  timeOut: 3000,
  closeButton: true,
  progressBar: true
};

Main(Vue);
Vue.http.interceptors.push(ApiHttpInterceptor);

Vue.use(Tabs);
Vue.use(Dropdown);
Vue.use(Modal);

Vue.use(CxltToastr, toastrConfigs);

Vue.use(
  new VueSocketIO({
    debug: process.env.VUE_APP_DEBUG,
    connection: io(process.env.VUE_APP_BASE_URI, {
      "reconnection delay": 0,
      "reopen delay": 0,
      "force new connection": true,
      transports: ["websocket"]
    })
  })
);

// Gtag plugin
Vue.use(GtagPlugin);

Vue.config.productionTip = false;
Vue.config.silent = process.env.NODE_ENV === "production";

// Components Globais
Vue.component("Loading", Loading);
Vue.component("Debug", zDebug);

// Font Awesome Icons
library.add(
  faBars,
  faBell,
  faGlobe,
  faHotel,
  faUsers,
  faTimes,
  faIdBadge,
  faFileAlt,
  faFolderOpen,
  faTimesCircle,
  faPlaneArrival,
  faPlaneDeparture,
  faClipboardList,
  faCalendarCheck,
  faCamera,
  faMobileAlt,
  faAt,
  faPencilAlt,
  faStar,
  faRedo,
  faCheck
);

// Components
Vue.component("fa-icon", FontAwesomeIcon);

Vue.$globalEvent.$on("httpError", error => {
  console.error(">> httpError <<", error);
  if (error) {
    if (error.status) {
      /* if (error.showException && error.status === 401) {
        FlashMessageService.error("INFRA.HTTP.ACCESS_DENIED_MESSAGE");
        // router.push({ name: "Search" });
      } else if (error.showException && error.status === 403) { */
      if (error.showException && error.status === 403) {
        FlashMessageService.error("INFRA.HTTP.ACCESS_DENIED_MESSAGE");
        router.push({ name: "Search" });
      } else if (error.showException && error.status === 412) {
        FlashMessageService.error("INFRA.HTTP.SESSION_EXPIRED_MESSAGE");
        router.push({ name: "Search" });
      } else if (error.status === 409) {
        console.error(error);
      } else if (
        error.showException &&
        error.status >= 404 &&
        error.status < 500
      ) {
        if (error.bodyText == null)
          FlashMessageService.warning(window.getMessage(error));
      } else if (error.status === 400 && error.showException) {
        FlashMessageService.warning(window.getMessage(error));
      } else if (error.showException) {
        FlashMessageService.error(window.getMessage(error), error);
      }
    } else {
      FlashMessageService.error(window.getMessage(error), error);
      // eslint-disable-next-line no-console
      console.error(`${error.operation} failed: ${window.getMessage(error)}`);
    }
  }
});

// Chamamos o AppLoadService para inicializar alguns dados (como estilo customizado no admin)
// antes da criação da aplicação
const $initialLoader = document.getElementById("initialLoader");
store.commit("loader/START_LONG_LOADING");

$initialLoader.style = "diplay: block;";

new AppLoadService()
  .init()
  .then(() => {
    initApp();
  })
  .catch(() => {
    initApp();
    router.push({ name: "NotFound" });
  });

const initApp = () => {
  const reload = () => {
    if (process.env.NODE_ENV !== "development") {
      window.location.reload();
    }
  };

  new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
    mounted() {
      const self = this;
      Vue.$globalEvent.$on("onFlashMessage", item => {
        switch (item.type) {
          case "success":
            self.$toast.success({
              title: this.$t("GLOBAL.SUCCESS"),
              message: item.message
            });
            break;
          case "error":
            self.$toast.error({
              title: this.$t("GLOBAL.ERROR"),
              message: item.message
            });
            break;
          case "warning":
            self.$toast.warn({
              title: this.$t("GLOBAL.WARNING"),
              message: item.message
            });
            break;
          case "info":
            self.$toast.info({
              title: this.$t("GLOBAL.INFORMATION"),
              message: item.message
            });
            break;
        }
      });

      store.commit("loader/FINISH_LONG_LOADING");
      this.$nextTick(() => {
        $initialLoader.remove();
      });
    },
    created() {
      document.addEventListener("backbutton", reload, false);
      window.addEventListener("popstate", reload, false);
    },
    beforeDestroy() {
      document.removeEventListener("backbutton", reload);
      window.removeEventListener("popstate", reload);
    }
  }).$mount("#app");

  Vue.config.devtools = process.env.VUE_APP_DEBUG;
  Vue.config.debug = process.env.VUE_APP_DEBUG;
  Vue.config.silent = !process.env.VUE_APP_DEBUG;
};
